module.exports = __webpack_public_path__ + "img/outwards-agility.15da59e1.png";